document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.fortune__card');
  const resultBox = document.getElementById('fortune-result-box');
  const loveText = document.getElementById('fortune-love');
  const workText = document.getElementById('fortune-work');
  const messageText = document.getElementById('fortune-message');

  cards.forEach(card => {
    card.addEventListener('click', () => {
      cards.forEach(c => c.classList.remove('active'));
      card.classList.add('active');

      // data属性から取得
      loveText.textContent = card.dataset.love || '';
      workText.textContent = card.dataset.work || '';
      messageText.textContent = card.dataset.light || '';

      // 結果ボックスを表示
      resultBox.classList.add('visible');
      resultBox.scrollIntoView({ behavior: 'smooth' });
    });
  });
});
